import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliIndicatori');
export const actions = helper.createActions('portaliIndicatori', actionTypes);
